import { FC } from 'react';
import { Avatar, ListItemAvatar, ListItemButton, Paper, Stack, Typography } from '@mui/material';
import { Domain } from '../../graphql/generated/graphql.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

export interface DomainListItemProps {
  domain: Partial<Domain>;
  onClick?: (domain: Partial<Domain>) => void;
}

export const DomainListItem: FC<DomainListItemProps> = ({ domain, onClick }) => {
  if (!domain) {
    return null;
  }
  return (
    <Paper
      sx={{
        borderRadius: 2
      }}
    >
      <ListItemButton
        onClick={() => {
          if (onClick) {
            onClick(domain);
          }
        }}
        key={domain._id}
        alignItems="center"
        sx={{
          backgroundColor: domain.color,
          borderRadius: 2
        }}
      >
        {domain.iconUrl && (
          <ListItemAvatar>
            <Avatar alt={domain.title} src={domain.iconUrl} sx={{ height: '100%', minWidth: '64px' }} />
          </ListItemAvatar>
        )}
        <Stack>
          <Typography variant="h6">{domain.title}</Typography>
          <Typography variant="subtitle1">{domain.subTitle}</Typography>
        </Stack>
        {onClick && (
          <FontAwesomeIcon
            icon={faChevronRight}
            size="2x"
            style={{ marginLeft: 'auto' }} // Align to the right
          />
        )}
      </ListItemButton>
    </Paper>
  );
};
